import React from 'react';
import { TicketMessageChannel } from 'flow/types/Tickets';
import {
    FILE_SIZE_EXCEEDED,
    FILE_TYPE_NOT_ALLOWED,
} from 'flow/components/tickets/Input/Attachments/AttachmentUploadError';
import useAppContext from 'flow/hooks/useAppContext';
import BaseModal from 'flow/components/ui-components/BaseModal';
import FileTooLarge from './FileTooLarge';
import FileTypeNotAllowed from './FileTypeNotAllowed';

interface Props {
    channel?: TicketMessageChannel;
    fileExtensionUserFriendly?: string;
    fileMimeType?: string;
    reason?: string;
}

const TicketAttachmentNotAllowedDialog = ({
    channel,
    fileExtensionUserFriendly,
    fileMimeType,
    reason,
}: Props) => {
    const { i18next } = useAppContext();

    const getBody = () => {
        if (reason === FILE_TYPE_NOT_ALLOWED)
            return (
                <FileTypeNotAllowed
                    channel={channel}
                    mimeType={fileMimeType}
                    fileExtensionUserFriendly={fileExtensionUserFriendly}
                />
            );

        if (reason === FILE_SIZE_EXCEEDED)
            return <FileTooLarge channel={channel} mimeType={fileMimeType} />;

        return i18next.t('chat.attachment.tooltip.failed_to_send');
    };

    return (
        <BaseModal
            open={true}
            header={i18next.t('chat.attachment.tooltip.failed_to_send')}
            confirmButtonText={i18next.t('ok')}
            hideCancelButton={true}
            onSubmit={() => {}}
        >
            {getBody()}
        </BaseModal>
    );
};

export default TicketAttachmentNotAllowedDialog;
